import gql from 'graphql-tag';

import webpageFragment from '../fragments/webpageFragment';

export const queryWebpage = gql`
  query webpage($id: DokkioID!) {
    webpage(id: $id) {
      ...webpageFragment
    }
  }
  ${webpageFragment}
`;
export default queryWebpage;
